import { render, staticRenderFns } from "./EnergyConservationSelf0verview.vue?vue&type=template&id=28b97e67&scoped=true"
import script from "./EnergyConservationSelf0verview.vue?vue&type=script&lang=js"
export * from "./EnergyConservationSelf0verview.vue?vue&type=script&lang=js"
import style0 from "./EnergyConservationSelf0verview.vue?vue&type=style&index=0&id=28b97e67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b97e67",
  null
  
)

export default component.exports